/*
 *
 * PatientDataPage actions
 *
 */

import {
  CLOSE_MESSAGE,
  CLOSE_MESSAGE_ERROR,
  CLOSE_MESSAGE_SUCCESS,
  CLOSE_PRODUCTPLAN,
  CLOSE_TREATMENTPLAN,
  DEFAULT_ACTION,
  DELETE_PATIENT,
  GET_MESSAGE_DETAILS,
  GET_MESSAGE_DETAILS_ERROR,
  GET_MESSAGE_DETAILS_SUCCESS,
  GET_MESSAGES,
  GET_MESSAGES_ERROR,
  GET_MESSAGES_SUCCESS,
  GET_PATIENT,
  GET_PLANNED_TREATMENTS,
  GET_TREATMENT_HISTORY,
  RESET_DELETE_PATIENT_ERROR_MESSAGE,
  RESET_ORDER_REMAKE_REQUEST,
  RESET_SEND_TREATMENT_REFITTING_REQUEST,
  SEND_ORDER_REMAKE_REQUEST,
  SEND_ORDER_REMAKE_REQUEST_ERROR,
  SEND_ORDER_REMAKE_REQUEST_SUCCESS,
  SEND_TREATMENT_REFITTING_REQUEST,
  SEND_TREATMENT_REFITTING_REQUEST_ERROR,
  SEND_TREATMENT_REFITTING_REQUEST_SUCCESS,
  SET_CURRENT_PAGE,
  SOFT_RESET,
  UPDATE_PATIENT,
} from "./constants";
import {HARD_RESET} from "../NewTreatmentPage/constants";
import {GET_ACTIVE_PRODUCT_PLAN} from "../OrderTreatment/constants";

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function getPatientAction(patientId) {
  return {
    type: GET_PATIENT,
    patientId,
  };
}

export function hardResetAction() {
  return {
    type: HARD_RESET,
  };
}

export function resetAction() {
  return {
    type: SOFT_RESET,
  };
}

export function resetErrorMessageAction() {
  return {
    type: RESET_DELETE_PATIENT_ERROR_MESSAGE,
  };
}

export function updatePatientAction(patient) {
  return {
    type: UPDATE_PATIENT,
    patient,
  };
}

export function getPlannedTreatmentsAction(patientId) {
  return {
    type: GET_PLANNED_TREATMENTS,
    patientId,
  };
}

export function getActiveProductPlan(patientId) {
  return {
    type: GET_ACTIVE_PRODUCT_PLAN,
    patientId,
  };
}


export function getTreatmentHistoryAction(patientId) {
  return {
    type: GET_TREATMENT_HISTORY,
    patientId,
  };
}

export function deletePatient(patient) {
  return {
    type: DELETE_PATIENT,
    patient,
  };
}

export function closeTreatmentPlan(treatmentPlanId) {
  return {
    type: CLOSE_TREATMENTPLAN,
    treatmentPlanId,
  };
}

export function closeProductPlan(productPlanId) {
  return {
    type: CLOSE_PRODUCTPLAN,
    productPlanId,
  };
}

export function getMessageDetails(id) {
  return {
    type: GET_MESSAGE_DETAILS,
    id,
  };
}

export function getMessageDetailsSuccess(data) {
  return {
    type: GET_MESSAGE_DETAILS_SUCCESS,
    data,
  };
}

export function getMessageDetailsError(error) {
  return {
    type: GET_MESSAGE_DETAILS_ERROR,
    error,
  };
}

export function closeMessage(id) {
  return {
    type: CLOSE_MESSAGE,
    id,
  };
}

export function closeMessageSuccess(data) {
  return {
    type: CLOSE_MESSAGE_SUCCESS,
    data,
  };
}

export function closeMessageError(error) {
  return {
    type: CLOSE_MESSAGE_ERROR,
    error,
  };
}

export function getMessages({ patientId, filter, status, limit, offset }) {
  return {
    type: GET_MESSAGES,
    patientId,
    filter,
    status,
    limit,
    offset,
  };
}

export function getMessagesSuccess(data) {
  return {
    type: GET_MESSAGES_SUCCESS,
    data,
  };
}

export function getMessagesError(error) {
  return {
    type: GET_MESSAGES_ERROR,
    error,
  };
}

export function setCurrentPage(page) {
  return {
    type: SET_CURRENT_PAGE,
    page,
  };
}

export function sendRemakeRequest({
  practiceId,
  productOrderId,
  remakeRequest,
}) {
  return {
    type: SEND_ORDER_REMAKE_REQUEST,
    practiceId,
    productOrderId,
    remakeRequest,
  };
}

export function sendRemakeRequestSuccess(data) {
  return {
    type: SEND_ORDER_REMAKE_REQUEST_SUCCESS,
    data,
  };
}

export function sendRemakeRequestError(error) {
  return {
    type: SEND_ORDER_REMAKE_REQUEST_ERROR,
    error,
  };
}

export function resetRemakeProductOrder() {
  return {
    type: RESET_ORDER_REMAKE_REQUEST,
  };
}

export function refittingTreatment({practiceId,plannedTreatmentId}) {
  return {
    type: SEND_TREATMENT_REFITTING_REQUEST,
    practiceId,
    plannedTreatmentId
  };
}

export function refittingTreatmentSuccess(data) {
  return {
    type: SEND_TREATMENT_REFITTING_REQUEST_SUCCESS,
    data,
  };
}

export function refittingTreatmentError(error) {
  return {
    type: SEND_TREATMENT_REFITTING_REQUEST_ERROR,
    error,
  };
}

export function resetRefittingTreatment() {
  return {
    type: RESET_SEND_TREATMENT_REFITTING_REQUEST,
  };
}
